<div class="content">

    <h2 class="dialog-title">{{dialogData['title']}}</h2>
    <div class="dialog-content">
        <div class="maincontainer">
            <nz-spin [nzSpinning]="loading" nzSize="large">
            <nz-tabs>
                <nz-tab [nzTitle]="'meli.form.attributes'|translateTA">
                    <div class="list-content">
                        <ul>
                            <li *ngFor="let item of result['attributes']">
                                <b>{{item.name}}:</b> {{ item.value_name}}
                            </li>
                        </ul>
                    </div>
                </nz-tab>
                <nz-tab [nzTitle]="'meli.form.step.var'|translateTA">
                    <div class="variation_body">
                        <meli-variation [melidata]="(resultOb.asObservable() | async)"></meli-variation>
                    </div>
                </nz-tab>
            </nz-tabs>
            </nz-spin>
        </div>
    </div>
    <div class="dialog-actions">
        <button nz-button nzType="primary" (click)="dialogRef.close(true)" cdkFocusInitial>{{'meli.item.ok'|translateTA}}</button>
    </div>

</div>
